import { render } from "./base-coach-mark_action.vue?vue&type=template&id=2d6c6830&ts=true"
import script from "./base-coach-mark_action.vue?vue&type=script&lang=ts"
export * from "./base-coach-mark_action.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__